<template>
  <v-container>
      <h1>Übersicht</h1>
      <v-row>
        <v-col cols="12" lg="12">
            <v-card>
                <v-card-text>
                    <p class="subtitle-1 font-weight-regular">Über die kostenlose Google Suche kommen Hunderttausende Webseitenbesucher zu Ihnen. Platt ausgedrückt, kann man diesen Kanal als “SEO” bezeichnen. Doch er ist viel mehr: Bei den meisten Unternehmen machen diese Webseitenbesucher 40% bis 60% des Umsatzes aus.</p>
                    <p class="subtitle-1 font-weight-regular">Während jeder bei Google Adwords ausgegebene Franken nur einmalig wirksam. Massnahmen hingegen, die Ihre Positionierung bei der kostenlosen Suchmaschine fördern, wirken jeden Tag und jede Woche - über Jahre hinweg. Darum sind diese um den Faktor 15 bis 30 effektiver. In diesem Cockpit finden Sie die KPIs, die Ihnen das Marketing Team vielleicht nicht liefert, weil sie schonungslos aufzeigen, wo Ihr Unternehmen Defizite hat.</p>
                </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <v-progress-linear indeterminate class="mt-5 mb-2" v-if="loading" />
      <v-row v-if="!loading">
        <v-col cols="12" lg="6" v-for="p in products" :key="p.id">
          <v-card>
              <v-card-text>
                <product-selector :id="p.id" :preview="true" :preload="p.data" />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" :to="{ name: 'ProductView', params: { id: p.id } }" text>View Dashboard</v-btn>
              </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import ProductSelector from "@/components/products/ProductSelector.vue";
import { api } from "@/services/api";

export default {
    name: 'Products',
    data: () => ({
        products: [],
        loading: true
    }),
    async created() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            this.loading = true;

            this.products = await api("/products/dashboard");

            this.loading = false;
        }
    },
    components: { ProductSelector }
};
</script>